/**
 * Measure point management for CDP SDK.
 */

import { CDPSession, getSession } from '../session';

export class MeasurePointManager {
  constructor(private readonly session: CDPSession = getSession()) {}

  async downloadTemplate(params?: Record<string, any>): Promise<Blob> {
    return this.session.request('GET', '/api/cdp/device_measure_point/downloadTemplate', {
      params,
      responseType: 'blob',
    });
  }

  async downloadTemplate2(params?: Record<string, any>): Promise<Blob> {
    return this.session.request('GET', '/api/cdp/device_measure_point/downloadTemplate2', {
      params,
      responseType: 'blob',
    });
  }

  async uploadMeasurePoints(file: File | Blob, params?: Record<string, any>): Promise<Record<string, any>> {
    const formData = new FormData();
    formData.append('file', file);
    return this.session.post('/api/cdp/device_measure_point/upload', {
      data: formData,
      params,
      headers: {},
    });
  }

  async getHistoryCaches(params?: Record<string, any>): Promise<Record<string, any>> {
    return this.session.get('/api/cdp/measure_point_data/history/caches', { params });
  }

  async subscribe(data: Record<string, any>): Promise<Record<string, any>> {
    return this.session.post('/api/cdp/measure_point_data/subscribe', { data });
  }

  async unsubscribe(data: Record<string, any>): Promise<Record<string, any>> {
    return this.session.post('/api/cdp/measure_point_data/unsubscribe', { data });
  }

  async getCachesScenes(params?: Record<string, any>): Promise<Record<string, any>> {
    return this.session.get('/api/cdp/measure_point_data/caches/scenes', { params });
  }

  async getDeviceHistory(params?: Record<string, any>): Promise<Record<string, any>> {
    return this.session.get('/api/cdp/measure_point_data/devices/history', { params });
  }

  async getDeviceStatistic(params?: Record<string, any>): Promise<Record<string, any>> {
    return this.session.get('/api/cdp/measure_point_data/devices/statistic', { params });
  }
}
